import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { apiRequest } from "../services/apiService";
import { setLoading } from "../redux/slices/supplierReportingSlice";

const useApiFetch = (endpoint, action) => {
  const dispatch = useDispatch();

  useEffect(() => {
    const fetchData = async () => {
      dispatch(setLoading(true));
      try {
        const result = await apiRequest("GET", endpoint);
        dispatch(action(result));
      } catch (error) {
        console.error(`Error fetching data from ${endpoint}:`, error);
      }
    };

    fetchData();
  }, [dispatch, endpoint, action]);
};

export default useApiFetch;
